import { frontendURL } from '../../../helper/URLHelper';

const ClaudiaLayout = () => import('./components/ClaudiaLayout.vue');
const EddieView = () => import('../eddie/pages/EddieView.vue');
const ClaudiaAgentsView = () => import('./pages/ClaudiaAgentsView.vue');
const ClaudiaToolsView = () => import('./pages/ClaudiaToolsView.vue');
const ClaudiaMcpView = () => import('./pages/ClaudiaMcpView.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/claudia'),
      name: 'claudia_app',
      component: ClaudiaLayout,
      meta: {
        permissions: ['administrator', 'cx_engineer'],
      },
      children: [
        {
          path: '',
          redirect: 'view',
        },
        {
          path: 'view',
          name: 'eddie_view',
          component: EddieView,
          meta: {
            permissions: ['administrator', 'cx_engineer'],
          },
        },
        {
          path: 'agents',
          name: 'claudia_agents',
          component: ClaudiaAgentsView,
          meta: {
            permissions: ['administrator', 'cx_engineer'],
          },
        },
        {
          path: 'tools',
          name: 'claudia_tools',
          component: ClaudiaToolsView,
          meta: {
            permissions: ['administrator', 'cx_engineer'],
          },
        },
        {
          path: 'mcp',
          name: 'claudia_mcp',
          component: ClaudiaMcpView,
          meta: {
            permissions: ['administrator', 'cx_engineer'],
          },
        },
      ],
    },
  ],
};
